export default "__VITE_ASSET__Ph5S7PqS__"